import React from "react";
import { Link } from "react-router-dom";
import { InfoWindow } from "react-google-maps";

import styled from "styled-components";
import { colors } from "../../theme";

import { Desktop, Mobile } from "../../components/Breakpoints";

const Window = styled.div`
  max-width: 300px;
  padding: 10px;
`;

const Title = styled.h2`
  color: #43934f;
  font-size: 30px;
  line-height: 31px;
  margin: 0;
`;

const Body = styled.p`
  font-size: 20px;
  line-height: 24px;
`;

const Party = styled.h3`
  color: ${colors.darkGreen};
  margin-bottom: ${props => (props.marginBottom ? "10px" : "Opx")};
`;

const Button = styled(Link)`
  border-radius: 5px;
  background-color: #1a3224;
  display: inline-block;
  padding: 10px;
  font-size: 18px;
  z-index: 5;
  margin-right: 10px;
  text-decoration: none;
  font-weight: bold;
  text-align: center;
  color: white;
`;

const DesktopVersion = ({ emoji, isFiltered }) => (
  <React.Fragment>
    <Party>{emoji.party}</Party>
    <Title>{emoji.title}</Title>
    <Body>{emoji.body}</Body>
    {!isFiltered && (
      <Button to={`/gemeente/${emoji.citySlug}/${emoji.partySlug}`}>
        Toon alle voorstellen van {emoji.party}
      </Button>
    )}
  </React.Fragment>
);

const MobileVersion = ({ emoji, isFiltered, onClose }) => (
  <React.Fragment>
    <Title>“{emoji.title}”</Title>
    <Party marginBottom={true}>— {emoji.party}</Party>
    <Button
      onClick={() => onClose()}
      to={`/gemeente/${emoji.citySlug}/${emoji.partySlug}/${emoji.id}`}
    >
      lees verder
    </Button>
  </React.Fragment>
);

const Info = ({ emoji, onClose, isFiltered }) => (
  <InfoWindow
    position={{ lat: emoji.lat, lng: emoji.lng }}
    options={{
      pixelOffset: new window.google.maps.Size(-24, -44)
    }}
    onCloseClick={() => onClose(false)}
  >
    <Window>
      <Mobile>
        <MobileVersion
          emoji={emoji}
          isFiltered={isFiltered}
          onClose={onClose}
        />
      </Mobile>
      <Desktop>
        <DesktopVersion
          emoji={emoji}
          isFiltered={isFiltered}
          onClose={onClose}
        />
      </Desktop>
    </Window>
  </InfoWindow>
);

export default Info;



// WEBPACK FOOTER //
// ./src/pages/City/Info.js